import { getModifier, createModifier, updateModifier, queryModifiers, bulkCreateModifiers, deleteModifier, bulkDeleteModifiers, countModifiers, bulkUpdateModifiers } from '@wix/ambassador-restaurants-menus-v1-item-modifier/http';
import { MAX_NUMBER_OF_MODIFIERS_FROM_SERVER, getEntityChunks, orderEntitiesById, BULK_DELETE_CHUNK_SIZE, callInChunks } from './utils';
import { ErrorTypes } from '../types/api';
import { BaseAPIClient } from './BaseAPIClient';
export class ModifiersClient extends BaseAPIClient {
  async getById(modifierId) {
    const response = await this.request(getModifier, {
      modifierId
    });
    return response.data.modifier;
  }
  async getBulk(args) {
    var _args$ids;
    let idChunks;
    let modifiers = [];
    let pagingMetadata;
    if (args != null && (_args$ids = args.ids) != null && _args$ids.length) {
      idChunks = getEntityChunks(args == null ? void 0 : args.ids, MAX_NUMBER_OF_MODIFIERS_FROM_SERVER);
      const modifiersInChunks = await Promise.all(idChunks.map(async chunk => {
        const query = {
          filter: {
            id: {
              $in: chunk || []
            }
          }
        };
        const {
          data
        } = await this.request(queryModifiers, {
          query
        });
        return data.modifiers || [];
      }));
      modifiers.push(...modifiersInChunks.flatMap(modifier => modifier));
      const modifiersByClientOrder = orderEntitiesById(args.ids, modifiers);
      modifiers = modifiersByClientOrder;
    } else {
      const {
        data
      } = await this.request(queryModifiers, {
        query: {
          cursorPaging: args == null ? void 0 : args.paging
        }
      });
      modifiers = data.modifiers;
      pagingMetadata = data.pagingMetadata;
    }
    return {
      data: modifiers,
      pagingMetadata
    };
  }
  async create(modifier) {
    const response = await this.request(createModifier, {
      modifier: {
        ...modifier
      }
    });
    return response.data.modifier;
  }
  async update(modifier) {
    const response = await this.request(updateModifier, {
      modifier: {
        ...modifier
      }
    });
    return response.data.modifier;
  }
  async query(query) {
    const response = await this.request(queryModifiers, {
      query
    });
    return {
      data: response.data.modifiers,
      pagingMetadata: response.data.pagingMetadata
    };
  }
  async bulkCreate(modifiers) {
    const response = await this.request(bulkCreateModifiers, {
      modifiers: modifiers.map(modifier => ({
        ...modifier
      })),
      returnEntity: true
    });
    const results = response.data.results || [];
    return results.map(result => result.modifier);
  }
  async delete(modifierId) {
    const response = await this.request(deleteModifier, {
      modifierId
    });
    return response.data;
  }
  async bulkDelete(modifierIds) {
    var _response$bulkActionM;
    const response = await callInChunks(chunkModifierIds => this.request(bulkDeleteModifiers, {
      ids: chunkModifierIds
    }), modifierIds, BULK_DELETE_CHUNK_SIZE);
    if ((_response$bulkActionM = response.bulkActionMetadata) != null && _response$bulkActionM.totalFailures) {
      var _response$results;
      const errors = ((_response$results = response.results) == null ? void 0 : _response$results.filter(result => {
        var _result$itemMetadata;
        return (_result$itemMetadata = result.itemMetadata) == null ? void 0 : _result$itemMetadata.error;
      })) || [];
      const errorMessage = {
        name: ErrorTypes.BULK_DELETE_MODIFIERS,
        message: errors.map(result => {
          var _result$itemMetadata2;
          return (_result$itemMetadata2 = result.itemMetadata) == null ? void 0 : _result$itemMetadata2.error;
        }).join(', ')
      };
      throw new Error('Failed to delete modifiers', {
        cause: errorMessage
      });
    }
    return {};
  }
  async countModifiers(filter) {
    const response = await this.request(countModifiers, {
      filter
    });
    return response.data.count;
  }
  async bulkUpdate(modifiers) {
    const response = await this.request(bulkUpdateModifiers, {
      modifiers: modifiers.map(modifier => ({
        modifier
      })),
      returnEntity: true
    });
    const results = response.data.results || [];
    return results.map(result => result.modifier);
  }
}
//# sourceMappingURL=ModifiersClient.js.map